module.exports = __webpack_public_path__ + "static/img/s502.7fe0ba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s502.png
// module id = 564
// module chunks = 3